<template>
    <div class="wrapper">        
        <h1 class="title">
            <span>Identity Verification</span>                        
            <!-- <p class="guide">
                Step <em>{{ props.step }}</em> / {{ props.allstep }}
            </p> -->
        </h1>
        <p class="caption">
            1.Please enter your Aadhaar number and click "Verify".<br>
            2.We will send a verification code to the mobile number linked to your Aadhaar. <br>
            3.After receiving the code, please enter it in the popup window.<br>
            4.Please enter your real PAN ID and click "Next".
        </p>
        <div class="element-wrapper">
            <div class="element-title">
                    <h3>Aadhaar Number</h3>            
                </div>
            <div class="element-content">
                <label for="">Aadhaar No.</label>
                <div class="element-input-container">
                    <input type="tel" v-model="idNo" :readonly="verify_state" @input="commonInput" @focus="adaFocus($event)" @blur="adaBlurs($event)" maxlength="12" placeholder="Please input Aadhaar Number.">
                </div>
                <a href="javascript:void(0);" class="link" :class="{'verified':verify_state}" @click="clickVerify" v-text="verify_state ? 'Verified' : 'Verify'"></a>
            </div>
        </div>
        
        <div class="element-wrapper">
            <div class="element-title">
                    <h3>PAN</h3>            
                </div>
            <div class="element-content">
                <label for="">PAN ID</label>
                <div class="element-input-container">
                    <input type="text" v-model="panNo" @input="commonInput" maxlength="10"  @focus="bootomFocus" @blur="panBlurs($event)" placeholder="Please input PAN ID.">
                </div>                
            </div>
        </div>
        <!-- <a href="javascript:void(0);" class="changetouploda-text" @click="changeVerify">Verify though taking pictures</a>             -->
        <div class="placeholder"></div>
        <div class="btn-container">
            <a class='btn-submit' @click="submit">NEXT</a>
        </div>
        <div class="dialog-wrapper" v-show="verify_dialog_show">
            <div class="dialog-code change">
                <div class="dialog-header">
                    Can not finish the verification?
                </div>
                <div class="dialog-content">
                    <p class="dialog-caption">
                        Change another way to finish the verification
                    </p>                    
                    <div class="dialog-btn-container">
                        <a class='submit-code' href="javascript:void(0);" @click="changeVerify" >Change</a>
                    </div>
                </div>
            </div>
        </div>   

        <div class="dialog-wrapper" v-show="code_dialog_show">
            <div class="dialog-code">
                <div class="dialog-header">
                    Verify Your IdNo.
                </div>
                <div class="dialog-content">
                    <p class="dialog-caption">
                        Please use Aadhaar bound mobile number to receive OTP
                    </p>
                    <div class="form-element-container">
                        <div class="input-element">
                            <input type="tel" @input="codeInput" @focus="adaCodeFocus($event)" @blur="adaCodeBlurs($event)"  placeholder="Please enter the OTP" id="code" v-model="verify_code">
                        </div>
                        <a href="javascript:void(0);" class="send-otp" v-text="otp_text" @click="clickVerify"></a>
                    </div>
                    <div class="dialog-btn-container">
                        <a class='submit-code' href="javascript:void(0);" @click="verify" >Verify</a>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<style lang="less" scoped>
.changetouploda-text{
    display: block;
    width: 400px;
    text-align: center;
    font-size:26px;
    color:#C393FF;
    margin:50px auto;
    text-decoration: underline;
}
.caption{
    padding:10px 0;
    color:#C393FF;
    line-height: 1.5;
    font-size: 24px;
}
.dialog-wrapper{
    position:fixed;
    width: 100%;
    height: 100%;
    left:0;
    top:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.6);    
    .dialog-code{
        width:600px;
        height:550px;
        margin:0 auto;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        background:#fff;
        padding:40px;
        border-radius: 20px;
        &.change{
            height:auto
        }
        .dialog-header{
            margin:20px 0;
            text-align: center;
            color:#C393FF;
            font-size: 40px;
        }
    }
    .dialog-content{        
        .dialog-btn-container{
            width: 450px;
            margin:100px auto 0 auto;
            .submit-code{
                display:block;
                width: 450px;
                height: 100px;
                line-height: 100px;
                text-align: center;
                font-size: 36px;                
                border-radius: 10px;
                background:#C393FF;
                color:#fff;
            }
        }
        .dialog-caption{
            font-size: 28px;
            color:#C393FF;
            margin-top: 50px;
        }
        .form-element-container{
            display:flex;
            justify-content: space-between;
            align-items: center;
            border-bottom:1px solid #C393FF;
            margin-top: 50px;
            padding:20px 0;
            .input-element{
                input{
                    display: block;
                    width: 100%;
                    height:100%;
                    color:#C393FF;
                    font-size: 30px;
                    border:none;
                    padding:0;
                }
            }
            .send-otp{
                display: block;
                width:150px;
                height:40px;
                padding:10px;
                text-align: center;
                color:#fff;
                font-size: 28px;
                line-height: 40px;
                background:#C393FF;
                border-radius: 10px;
            }
        }

    }
}
.element-wrapper{
    .element-title{
        padding:30px 0;
        h3{
            font-size:28px;
            color:#333; 
        }
    }
    .element-content {
        padding:30px;
        position:relative;
        border:2px solid #EAEBEF;                    
        label{
            display: block;
            color:#9B9FA3;
            font-size:24px;
        }
        .element-input-container{
            height:50px;
            padding:10px 0;
            input{
                font-size:24px;
                color:#C393FF;
                height:36px;
                line-height: 36px;
                height: 100%;
                border:none;
                width: 100%;
            }
        }
        .link{
            display:block;
            width:140px;
            height:60px;
            text-align:center;
            line-height:60px;
            font-size: 24px;
            background:#C393FF;
            color:#fff;
            position:absolute;
            top:18px;
            right:20px;
            border-radius: 10px;
            &.verified{
                background:#f4d98f;
            }
        }
    }
    
}
.btn-container{
    position: fixed;
    left:0;
    bottom: 0;        
    background:#fff;
    padding:40px;
    // padding:40px;
    .btn-submit{
        display: block;
        width: 670px;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-radius: 12px;
        background:#C393FF;
        font-size: 32px;
        margin:0 auto;
        color:#fff;
    }
}
.placeholder{
    height: 176px;        
}
.hih-caption{
    color:#A59BB3;
    font-size:28px;
    margin-bottom: 30px;
    line-height: 1.5;
}
.wrapper{
    padding:20px 40px;
    .guide{
        color:#A59BB3;
        font-size: 30px;
        em{
            color:#C393FF;
            font-weight: 700;
        }
    }
    .title{
        color:#1F201E;
        font-weight: 700;
        font-size: 40px;
        margin: 0 0 50px 0;  
    }
}
</style>
<script>
import { onMounted, getCurrentInstance,ref, onBeforeMount, onBeforeUnmount  } from 'vue'
import { useRouter } from 'vue-router'
import { adaPan, zySendCode, verifyZyCode, getKycinfo} from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
import { v4 as uuidv4} from 'uuid'
export default {
    props:{
        step:String,
        allstep:String
    },
    setup(props, ctx) {
        const $loading = useLoading()
        const store = useStore()

        const idNo = ref("")
        const panNo = ref("")
        const router = useRouter()
        const proxy = getCurrentInstance().proxy   
        const route = router.currentRoute
        const verify_dialog_show = ref(false)
        const code_dialog_show = ref(false)
        const otp_text = ref("send")
        const verify_code = ref("")
        const verify_state = ref(false)
        const verify_ing = ref(false)
        let requestId = ref(uuidv4())
        let inputCount = ref(0)
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"kyc_page_szy_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"kyc_szy_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        // 提交    
        const submit = async () => {
            const loader = $loading.show({
                container: null
            }) 
            store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click"})
            const data = await adaPan({
                idNo:idNo.value,
                panNo:panNo.value,
            })
            if(data.code == 0) {
                loader.hide()
                store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success"})
                store.dispatch("uploadBury")
                router.replace({
                    "path":"/auth/index",
                    "query":{
                        "pid":route.value.query.pid
                    }
                })
            } else {
                store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success", message:data.msg})
                proxy.$toast.show(data.msg)
                
            }
        }    
        onMounted(async () => {
            document.body.style.background = "#fff"
            getKycinfo().then((res)=>{
                if(res.code == 0) {
                    idNo.value = res.data.aadhaar                    
                }
            })
            // document.body.style.background = '#F8F8F8'                        
        }) 
        const commonInput = () => {
            inputCount.value = inputCount.value + 1
        }
        // 输入验证 
        const codeInput = (e) => {
            // const reg = /[a-zA-Z!@#$%^&*(){}[].?]]/
            const reg1 = /\D+/
            const v = e.target.value
            if(reg1.test(v)) {
                verify_code.value = v.substring(0, v.length - 1)
            }
            else if(v.length > 6) {
                verify_code.value = v.substring(0, v.length - 1)                    
            }
            inputCount.value = inputCount.value + 1
        }  
        // 弹窗验证
        const verify = async () => {
            const loader = $loading.show({
                container: null
            })        
            let resp = await verifyZyCode({
                aadhaar:idNo.value,
                otp: verify_code.value
            })
            loader.hide()
            if(resp.code == '0') {
                verify_state.value = true
                code_dialog_show.value = false

            } else if (resp.code == '-1100001') {
                verify_dialog_show.value = true
                code_dialog_show.value = false  
                shouldGoState.value = 2
            }  else if (resp.code == '-1100003') {
                verify_dialog_show.value = true
                code_dialog_show.value = false  
                shouldGoState.value = 3
            } else {
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success",message: data.msg})
                proxy.$toast.show(resp.msg)
            }
        } 
        let st = 0  
        const shouldGoState = ref(0)
        const changeVerify = () => {
            ctx.emit("changeState", shouldGoState.value)
        }
        const clickVerify = async () => {  
            // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click"})
            if(verify_ing.value)return 
            if(verify_state.value == 1)return 
            const loader = $loading.show({
                container: null
            }) 
            const data = await zySendCode({
                "aadhaar":idNo.value
            })
            if(data.code == 0) {     
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success"})
                // store.dispatch('uploadBury')           
                if(data.data.state == 0) {   
                    code_dialog_show.value = true                                     
                    if (data.data.success) {
                        verify_ing.value = true
                        let sec = 60
                        st = setInterval(()=>{                            
                            sec--
                            otp_text.value = `${sec}s`
                            if(sec <= 0) {
                                otp_text.value = "Resend"
                                clearInterval(st)
                                verify_ing.value = false
                            }
                        },1000)
                    } else {
                        proxy.$toast.show(data.data.message)        
                    }
                    loader.hide()
                }   
                if(data.data.state == 1){
                    verify_state.value = 1
                }              
            } else if (data.code == '-1100001') {
                verify_dialog_show.value = true
                code_dialog_show.value = false  
                shouldGoState.value = 2
            }  else if (data.code == '-1100003') {
                verify_dialog_show.value = true
                code_dialog_show.value = false  
                shouldGoState.value = 3
            } else {
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success",message: data.msg})
                proxy.$toast.show(data.msg)
            }            
            loader.hide()
        }
        const validate = () => {
            let res = true
            if(idNo.value == '') {
                proxy.$toast.show('Please Input IDcard No.')
                res =false
            } else if (panNo.value == '') {
                proxy.$toast.show('Please Input Pan Id. ')
                res =false
                
            } 
            return res
        }        
        const bootomFocus = (e) => {
            e.target.scrollIntoView({ block: "center" })
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['panNo']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const panBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['panNo']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }
        const adaBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['idNo']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }
        const adaFocus = (e)=>{            
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['idNo']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const adaCodeFocus = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['smsCode']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const adaCodeBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['smsCode']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }
        return {
            adaCodeBlurs,
            adaCodeFocus,
            panBlurs,
            adaBlurs,
            adaFocus,
            props,
            idNo,
            panNo,
            submit,
            validate,
            clickVerify,
            bootomFocus,
            code_dialog_show,
            verify_dialog_show,
            otp_text,
            codeInput,
            verify,
            verify_code,
            verify_state,
            commonInput,
            changeVerify
        }
        
    }
}
</script>